<template>
  <a class="btn btn-outline-blue btn-rounded" :href="actionUrl" data-toggle="modal"
                data-target="#convertBPointsModal"
               v-on:click="setupConversionForm">{{ actionButtonTitle }}</a>
</template>

<script>
export default {
  // Note: data-name, data-email and data-mobile becomes camel case in props
  props: [
    "dataActionUrl",
    "dataActionTitle",
    "dataPartner",
    "dataBrandName",
    "dataFieldIdTitle",
    "fieldIdName",
    "dataName",
    "dataMobile",
    "dataEmail"
  ],
  data() {
    return {
        actionUrl: this.dataActionUrl,
        actionButtonTitle: this.dataActionTitle
    };
  }
};
</script>